module.exports = __webpack_public_path__ + "h5/img/xiaowang.3bd3f9d4.jpg";